import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import {
  LanguageDto,
  LocalizedObjectDto,
  LocalizedObjectType,
  LocalizeObjectService,
  SystemService,
  UpsertLocalizedObjectCommand,
} from '@codegen/Vaimoo.Admin.API';
import { firstValueFrom } from 'rxjs';
import { UserService } from './user.service';
import { RolesType } from '@core/enums/roles-type.enum';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  private $languages = signal<LanguageDto[]>([]);

  $setlanguages(languages: LanguageDto[]) {
    this.$languages.set(languages);
  }

  $getlanguages(): WritableSignal<LanguageDto[]> {
    return this.$languages;
  }

  getlanguages(): LanguageDto[] {
    return this.$languages();
  }

  private systemServiceApi = inject(SystemService);
  private localizationServiceApi = inject(LocalizeObjectService);
  private userService = inject(UserService);

  async getLanguagesAsync(): Promise<LanguageDto[]> {
    const response = await firstValueFrom(this.systemServiceApi.languagesGet());
    return response?.languages || [];
  }

  async getLocalizedObjectsAsync(
    objectType: LocalizedObjectType,
    itemId: string,
  ): Promise<LocalizedObjectDto[]> {
    const response = await firstValueFrom(
      this.localizationServiceApi.localizedObjectObjectTypeItemIdGet(objectType, itemId),
    );
    return response?.localizedObjects || [];
  }

  async upsertLocalizedObjects(items: UpsertLocalizedObjectCommand) {
    return firstValueFrom(this.localizationServiceApi.localizedObjectUpsertPost(items));
  }

  hasWritePermission() {
    return this.userService.checkUserRoles([RolesType.LOCALIZE_OBJECT_UPSERT]);
  }
}
